export default function Audio({ url }: { url: string }) {
  return (
    <audio controls src={url}>
      <a href={url}>Download audio</a>
    </audio>
  );
}
